import React from 'react';
import { AddIcon, Box, Text } from '@common-fe/common-fe';

interface Props {
  title?: string;
  onAddGroup?: () => void;
}

const AddNewGroupButton: React.FC<Props> = ({ title, onAddGroup }) => {
  return (
    <Box direction="row" align="center" onClick={onAddGroup}>
      <AddIcon size="16px" color="textAccent" />
      <Text
        margin={{ left: 'spacing4' }}
        weight={700}
        color="textAccent">
        {title}
      </Text>
    </Box>
  );
};

export default AddNewGroupButton;
